var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlusIconUload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 4.66634C11.3333 4.2061 10.9602 3.83301 10.5 3.83301C10.0397 3.83301 9.66665 4.2061 9.66665 4.66634V9.66634H4.66665C4.20641 9.66634 3.83331 10.0394 3.83331 10.4997C3.83331 10.9599 4.20641 11.333 4.66665 11.333H9.66665V16.333C9.66665 16.7932 10.0397 17.1663 10.5 17.1663C10.9602 17.1663 11.3333 16.7932 11.3333 16.333V11.333H16.3333C16.7935 11.333 17.1666 10.9599 17.1666 10.4997C17.1666 10.0394 16.7935 9.66634 16.3333 9.66634H11.3333V4.66634Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIconUload);
export default __webpack_public_path__ + "static/media/plus_icon_uload.2ad02794454ac9303cc6f48593484d6d.svg";
export { ForwardRef as ReactComponent };